@if (kpis().length > 0) {
    <div class="detail-content" style="margin-top: 18px;">
        <div class="detail-content-header">
            <span class="material-symbols-outlined custom-doc ">description</span>
            <h3>{{ 'KPI.MAIN_TITLE' | translate }}</h3>

            <div class="accordion-buttons">
                @if (activedAccordionItems.length !== kpis().length) {
                    <p-button styleClass="p-button-rounded p-button-secondary p-button-text" tooltipPosition="top" [pTooltip]="'REQUEST_DETAIL.EXPAND_ALL' | translate" (click)="expandAll()">
                        <span class="material-symbols-outlined"> keyboard_arrow_down </span>
                    </p-button>
                }

                @if (activedAccordionItems.length !== 0) {
                <p-button styleClass="p-button-rounded p-button-secondary p-button-text" tooltipPosition="top" [pTooltip]="'REQUEST_DETAIL.COLLAPSE_ALL' | translate" (click)="colapseAll()">
                    <span class="material-symbols-outlined"> keyboard_arrow_up </span>
                </p-button>
                }
            </div>
        </div>

        <p-accordion [multiple]="true" [(value)]="activedAccordionItems">
            @for (kpiGroup of kpis(); track $index) {
                <p-accordion-panel [value]="$index">
                    <p-accordion-header>
                        {{ kpiGroup.title | translate }}
                    </p-accordion-header>
                    <p-accordion-content>
                    <table>
                        <tbody>
                            @for (kpi of kpiGroup.kpis; track $index) {
                                <tr>
                                    <td class="W356">
                                        <div class="kpi-cell">
                                            <span>{{ kpi.key | translate }}</span>
                                            @if (kpi.description) {
                                                <span class="material-symbols-outlined kpi-info" tooltipPosition="top" [pTooltip]="kpi.description | translate" tooltipStyleClass="kpi-tooltip"> info </span>
                                            }
                                        </div>
                                    </td>

                                    <td [class.od-rating-container]="kpi.key === scoreKey">
                                        @if (kpi.key === scoreKey) {
                                            <div class="od-rating">
                                                @for (cell of scoreRatingCells; track cell.label) {
                                                    <span tooltipPosition="top" [pTooltip]="'OD_RATING_TOOLTIP.' + cell.label | translate" [class]="getRatingCellClasses(kpi.value, cell.label)">
                                                        {{ 'OD_RATING.' + cell.label | translate }}
                                                    </span>
                                                }
                                            </div>
                                        } @else if(isNumber(kpi.value)) {
                                            {{ +kpi.value | number:'1.0-2':'es-ES' }}
                                        } @else {
                                            <div style="white-space: pre-line">
                                                {{ translate(kpi.value) }}
                                            </div>
                                        }
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                    </p-accordion-content>
                </p-accordion-panel>
            }
        </p-accordion>
    </div>
}
